import { Component, OnInit, Input } from '@angular/core';

interface TableField {
	fieldName: string;
	label?: string;
	Metadata?: any[];
}

@Component({
	selector: 'cv-cvds-field-table',
	templateUrl: './cvds-field-table.component.html',
	styleUrls: ['../../cvds-structures.component.scss']
})
export class CvdsFieldTableComponent implements OnInit {
	@Input() items: TableField[] = [];
	@Input() title: string;

	itemsChunk = [];
	async ngOnInit(): Promise<void> {
		const items = [];
		const chunk = 3;

		for (let i = 0; i < this.items.length; i += chunk) {
			items.push(this.items.slice(i, i + chunk));
		}

		this.itemsChunk = items;
	}
}
